import { SizableText, SmartLink, YStack, XStackProps, Box } from '@my/ui'
import millify from 'millify'
import { GroupAvatar } from '../../components'

export interface GroupCardBasicProps {
  id: string
  name: string
  href: string
  totalMembers?: number
  visibility?: string
  profileImage?: {
    url?: string
    alt?: string
  }
}

export const GroupCardBasic = ({
  id,
  name,
  href,
  profileImage,
  totalMembers = 0,
  visibility,
  ...props
}: GroupCardBasicProps & XStackProps) => {
  return (
    <SmartLink Component={Box} href={href} gap="$2" flex={1} ai="flex-start" pressable {...props}>
      <GroupAvatar
        width={44}
        height={44}
        src={profileImage?.url}
        alt={profileImage?.alt}
        rounded={false}
      />
      <YStack flex={1} gap="$1" pl="$2.5">
        <SizableText numberOfLines={3} lineHeight="$4" size="$5" fow="600">
          {name}
        </SizableText>
        {typeof totalMembers === 'number' && (
          <SizableText color="$overlay11" size="$2">
            {millify(totalMembers)} {totalMembers === 1 ? 'Member' : 'Members'} |{' '}
            {visibility === 'public' ? 'Public' : 'Private'}
          </SizableText>
        )}
      </YStack>
    </SmartLink>
  )
}
